import { Controller } from "@hotwired/stimulus"
import { showBlock } from "lib/helpers"

// Triggers tab controller for _edit_triggers partial.
// Handles: create/update/remove triggers, modal management, form validation,
// webhook secret refresh.
export default class extends Controller {
  static values = {
    errorBlock: { type: String, default: "#chatbot-errors" },
  }

  connect() {
    this.initTriggerModal()
    this.initCreateTriggerHandler()
    this.initUpdateTriggerHandler()
    this.initRemoveTriggerHandler()
    this.initRefreshTriggerWebhookSecret()

    window.TriggerActionSelectHandler = (_event, obj) => this.triggerActionSelectHandler(obj)
    window.showEditTriggerModalHandler = (e, data) => this.showEditTriggerModalHandler(e, data)
    window.showRemoveTriggerConfirmation = (e, data) => this.showRemoveTriggerConfirmation(e, data)
  }

  triggerActionSelectHandler(selectedObject) {
    switch (selectedObject.value) {
      case 'webhook': $(".webhook-event-wrap").removeClass("hide"); $(".send-message-event-wrap").addClass("hide"); break
      case 'send_message': $(".webhook-event-wrap").addClass("hide"); $(".send-message-event-wrap").removeClass("hide"); break
      default: $(".webhook-event-wrap, .send-message-event-wrap").addClass("hide")
    }
  }

  initTriggerModal() {
    const self = this
    $(".add-trigger-btn").on('click.editTriggers', function (e) { self.newTriggerModalHandler(e) })
  }

  newTriggerModalHandler(e) {
    e.preventDefault()
    const createErrors = '#create-trigger-modal-errors'
    $("#trigger-modal").modal("show")
    $(createErrors).hide()
    const form = document.getElementById('create-trigger-form'); form.reset()
    const dropdown = form.querySelector('select-dropdown[name="chat_assistants_trigger[trigger_action]"]')
    if (dropdown) dropdown.reset()
    $(".webhook-event-wrap, .send-message-event-wrap").addClass("hide")
    setTimeout(() => this.initCreateTriggerValidation(), 100)
  }

  showEditTriggerModalHandler(e, data) {
    const updateErrors = '#update-trigger-modal-errors'
    $(updateErrors).hide()
    const self = this
    fetch(data.url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') } })
      .then(r => r.json())
      .then(triggerData => {
        if (triggerData.success) {
          const form = document.getElementById('update-trigger-form'); form.action = triggerData.update_url
          form.querySelector('#chat_assistants_trigger_name').value = triggerData.trigger.name
          form.querySelector('#chat_assistants_trigger_description').value = triggerData.trigger.description
          form.querySelector('#chat_assistants_trigger_event_value').value = triggerData.trigger.trigger_event_value
          form.querySelector('#chat_assistants_trigger_message_text').value = triggerData.trigger.message_text
          form.querySelector('#chat_assistants_trigger_webhook_url').value = triggerData.trigger.webhook_url
          form.querySelector('.assistant_trigger_webhook_secret').value = triggerData.trigger.webhook_secret
          const eventDropdown = form.querySelector('select-dropdown[name="chat_assistants_trigger[trigger_event]"]')
          if (eventDropdown) eventDropdown.value = triggerData.trigger.trigger_event
          const actionDropdown = form.querySelector('select-dropdown[name="chat_assistants_trigger[trigger_action]"]')
          if (actionDropdown) actionDropdown.value = triggerData.trigger.trigger_action
          $(".refresh_trigger_webhook_secret").attr("href", triggerData.refresh_webhook_secret_url)
          $(".trigger-webhook-secret-copy").data("copy-value", triggerData.trigger.webhook_secret)
          const submitBtn = document.getElementById('trigger-modal-update-button')
          if (submitBtn) submitBtn.disabled = false
          $("#edit-trigger-modal").modal("show")
          if (actionDropdown && triggerData.trigger.trigger_action) self.triggerActionSelectHandler({ value: triggerData.trigger.trigger_action })
          self.refreshTextCounter()
          setTimeout(() => self.initUpdateTriggerValidation(), 100)
        } else showBlock(self.errorBlockValue, triggerData.message)
      })
      .catch(() => showBlock(self.errorBlockValue, "An error occurred while fetching the trigger data."))
  }

  showRemoveTriggerConfirmation(e, data) {
    const submitBtn = document.getElementById('confirm-delete-trigger-button')
    if (submitBtn) submitBtn.disabled = false
    $("#confirmation_delete_trigger").modal("show")
    $("#confirm-delete-trigger-form").attr("action", data.url)
  }

  initCreateTriggerHandler() {
    const self = this, createErrors = '#create-trigger-modal-errors'
    $(createErrors).hide()
    const form = $('#create-trigger-form')
    form.ajaxForm({
      dataType: 'JSON', method: "POST",
      beforeSend() { const btn = document.getElementById('trigger-modal-add-button'); if (btn) btn.disabled = true; $(createErrors).hide() },
      complete() { const btn = document.getElementById('trigger-modal-add-button'); if (btn) btn.disabled = false },
      success(response) {
        if (!response.success && response.invalid_messages_number) self.showValidationError("create-trigger-form", "chat_assistants_trigger_event_value", "Cannot create multiple triggers with same event.")
        else if (!response.success) { const error = $(createErrors); if (error.length === 1) error.after(error.clone()); showBlock(createErrors, response.message) }
        else { self.addFirstTriggerIfEmpty(response.data); $("#trigger-modal").modal("hide") }
      },
      error(response) { showBlock(createErrors, response.message || "An error occurred during request.") }
    })
  }

  initUpdateTriggerHandler() {
    const self = this
    const form = document.getElementById('update-trigger-form')
    if (!form) return
    form.addEventListener('submit', function (e) {
      e.preventDefault()
      const submitBtn = document.getElementById('trigger-modal-update-button')
      const errorBlock = document.getElementById('update_trigger_modal_errors_block')
      const formData = new FormData(form)
      if (submitBtn) submitBtn.disabled = true
      if (errorBlock) errorBlock.style.display = 'none'
      fetch(form.action, { method: 'PUT', body: formData })
        .then(r => { if (!r.ok) throw new Error('Network error'); return r.json() })
        .then(data => {
          if (!data.success && data.invalid_messages_number) self.showValidationError("update-trigger-form", "chat_assistants_trigger_event_value", "Cannot create multiple triggers with same event.")
          else if (!data.success && errorBlock) { showBlock(errorBlock, data.message) }
          else { $("#edit-trigger-modal").modal("hide") }
        })
        .catch(error => { if (errorBlock) showBlock(errorBlock, error.message || "An error occurred during request.") })
        .finally(() => { if (submitBtn) submitBtn.disabled = false })
    })
  }

  initRemoveTriggerHandler() {
    const deleteErrors = '#confirm-delete-trigger-errors'
    $("#confirm-delete-trigger-form").ajaxForm({
      dataType: 'JSON', method: "DELETE",
      success(response) {
        if (!response.success) { const error = $(deleteErrors); if (error.length === 1) error.after(error.clone()); showBlock(deleteErrors, response.message) }
        else {
          $("#confirmation_delete_trigger").modal("hide")
          const form = document.getElementById('confirm-delete-trigger-form')
          const url = form.getAttribute('action')
          const item = document.querySelector('dropdown-item[url="' + url + '"]')
          if (item) item.closest('li').remove()
          checkTriggerListEmpty()
        }
      },
      error(response) { showBlock(deleteErrors, response.message || "An error occurred during request.") }
    })

    function checkTriggerListEmpty() {
      const wrapper = document.getElementsByClassName('triggers-control-group')[0]
      const triggerList = document.getElementById('triggers-list')
      if (triggerList && triggerList.children.length === 0) {
        const emptyMessage = document.createElement('div'); emptyMessage.className = 'empty-trigger-list'
        const addBtn = document.createElement('a'); addBtn.className = 'add-trigger-btn new-btn'; addBtn.href = '#'; addBtn.textContent = 'Add'
        const emptyText = document.createElement('div'); emptyText.className = 'empty-trigger-list-text'; emptyText.textContent = 'No trigger added. Click on "Add" to add new trigger.'
        const addBtnWrap = document.getElementsByClassName('add-trigger-btn-wrap')[0]
        if (addBtnWrap) addBtnWrap.innerHTML = ''
        emptyMessage.appendChild(addBtn); emptyMessage.appendChild(emptyText)
        wrapper.appendChild(emptyMessage)
      }
    }
  }

  initRefreshTriggerWebhookSecret() {
    const self = this
    $(".refresh_trigger_webhook_secret").on('click.editTriggers', function (e) {
      e.preventDefault()
      $.ajax({
        url: this.href, type: "GET", dataType: "JSON",
        success(response) { if (response.success) { $(".assistant_trigger_webhook_secret").val(response.webhook_secret); $(".trigger-webhook-secret-copy").data("copy-value", response.webhook_secret) } else showBlock(self.errorBlockValue, response.message) },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }

  addFirstTriggerIfEmpty(data) {
    const wrapper = document.getElementsByClassName('triggers-control-group')[0]
    let triggerList = document.getElementById('triggers-list')
    if (!triggerList) { triggerList = document.createElement('ul'); triggerList.id = 'triggers-list' }
    const li = document.createElement('li'); li.className = 'trigger-item'
    const content = document.createElement('div'); content.className = 'trigger-item-content'
    const name = document.createElement('div'); name.className = 'trigger-item-name'; name.textContent = data.name
    const created = document.createElement('div'); created.className = 'trigger-item-created'; created.textContent = data.created_at
    content.appendChild(name); content.appendChild(created); li.appendChild(content)
    const controls = document.createElement('div'); controls.className = 'trigger-item-controls'
    const dropdown = document.createElement('menu-dropdown')
    const iconMore = document.createElement('div'); iconMore.className = 'icon-more'; iconMore.slot = 'trigger'; dropdown.appendChild(iconMore)
    const editItem = document.createElement('dropdown-item'); editItem.setAttribute('callback', 'showEditTriggerModalHandler'); editItem.setAttribute('url', data.edit_url); editItem.textContent = 'Edit'
    const removeItem = document.createElement('dropdown-item'); removeItem.setAttribute('callback', 'showRemoveTriggerConfirmation'); removeItem.setAttribute('url', data.remove_url); removeItem.textContent = 'Remove'
    dropdown.appendChild(editItem); dropdown.appendChild(removeItem)
    controls.appendChild(dropdown); li.appendChild(controls); triggerList.appendChild(li); wrapper.appendChild(triggerList)
    const addBtnWrap = document.getElementsByClassName('add-trigger-btn-wrap')[0]
    if (addBtnWrap) { addBtnWrap.innerHTML = ''; const addBtn = document.createElement('a'); addBtn.className = 'add-trigger-btn new-btn'; addBtn.href = '#'; addBtn.textContent = 'Add'; addBtn.addEventListener('click', (e) => this.newTriggerModalHandler(e)); addBtnWrap.appendChild(addBtn) }
    const emptyMsg = document.querySelector('.empty-trigger-list'); if (emptyMsg) emptyMsg.remove()
  }

  // ---- Validation ----
  validateForm(formId, submitButtonId) {
    const form = document.getElementById(formId), submitBtn = document.getElementById(submitButtonId)
    if (!form || !submitBtn) return
    const requiredFields = [form.querySelector('#chat_assistants_trigger_name'), form.querySelector('select-dropdown[name="chat_assistants_trigger[trigger_event]"]'), form.querySelector('select-dropdown[name="chat_assistants_trigger[trigger_action]"]'), form.querySelector('#chat_assistants_trigger_event_value')]
    const triggerActionDropdown = form.querySelector('select-dropdown[name="chat_assistants_trigger[trigger_action]"]')
    const messageTextField = form.querySelector('#chat_assistants_trigger_message_text')
    const webhookUrlField = form.querySelector('#chat_assistants_trigger_webhook_url')
    const eventValueField = form.querySelector('#chat_assistants_trigger_event_value')
    let allValid = true
    for (const field of requiredFields) {
      if (!field) continue
      const value = (field.tagName.toLowerCase() === 'select-dropdown' ? field.value : field.value.trim()) || ''
      if (!value.length) { allValid = false; break }
    }
    if (allValid && triggerActionDropdown) {
      const action = triggerActionDropdown.value
      if (action === 'send_message' && messageTextField && !messageTextField.value.trim()) allValid = false
      if (action === 'webhook' && webhookUrlField && !webhookUrlField.value.trim()) allValid = false
    }
    submitBtn.disabled = !allValid
    if (allValid) { if (eventValueField) { eventValueField.classList.remove('invalid'); const err = eventValueField.nextElementSibling; if (err && err.classList.contains('error-message')) err.remove() }; submitBtn.classList.remove('disabled') }
    else submitBtn.classList.add('disabled')
  }

  initCreateTriggerValidation() {
    const form = document.getElementById('create-trigger-form')
    if (!form) return
    const self = this
    ;['#chat_assistants_trigger_name', '#chat_assistants_trigger_event_value', '#chat_assistants_trigger_message_text', '#chat_assistants_trigger_webhook_url'].forEach(sel => {
      const field = form.querySelector(sel)
      if (field) { field.addEventListener('input', () => self.validateForm('create-trigger-form', 'trigger-modal-add-button')); field.addEventListener('change', () => self.validateForm('create-trigger-form', 'trigger-modal-add-button')) }
    })
    form.querySelectorAll('input[name="chat_assistants_trigger[trigger_action]"]').forEach(d => d.addEventListener('change', () => self.validateForm('create-trigger-form', 'trigger-modal-add-button')))
    this.validateForm('create-trigger-form', 'trigger-modal-add-button')
  }

  initUpdateTriggerValidation() {
    const form = document.getElementById('update-trigger-form')
    if (!form) return
    const self = this
    ;['#chat_assistants_trigger_name', '#chat_assistants_trigger_event_value', '#chat_assistants_trigger_message_text', '#chat_assistants_trigger_webhook_url'].forEach(sel => {
      const field = form.querySelector(sel)
      if (field) { field.addEventListener('input', () => self.validateForm('update-trigger-form', 'trigger-modal-update-button')); field.addEventListener('change', () => self.validateForm('update-trigger-form', 'trigger-modal-update-button')) }
    })
    form.querySelectorAll('input[name="chat_assistants_trigger[trigger_action]"]').forEach(d => d.addEventListener('change', () => self.validateForm('update-trigger-form', 'trigger-modal-update-button')))
    this.validateForm('update-trigger-form', 'trigger-modal-update-button')
  }

  showValidationError(formId, fieldId, message) {
    const form = document.getElementById(formId); if (!form) return
    const field = form.querySelector(`#${fieldId}`); if (!field) return
    field.classList.add('invalid')
    const existing = field.nextElementSibling
    if (existing && existing.classList.contains('error-message')) existing.remove()
    const errorMessage = document.createElement('div'); errorMessage.className = 'error-message'; errorMessage.textContent = message
    field.insertAdjacentElement('afterend', errorMessage)
  }

  refreshTextCounter() {
    $('textarea').each(function () { $(this).parent().find('.textaria-counter span').html($(this).val().length) })
    $('input[type="text"]').each(function () { $(this).parent().find('.textaria-counter span').html($(this).val().length) })
  }
}
